import { Injectable, inject } from '@angular/core';
import { Announcement, AnnouncementBarPage, ProductBadge } from '../../interfaces/store-configuration.interface';
import { StoreConfigurationRepositoryService } from '../store-configuration/store-configuration-repository.service';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService {
  private storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);


  getAnnouncement(page: AnnouncementBarPage): Announcement | null {
    const storeConfig = this.storeConfigurationRepositoryService.storeConfigurations();
    const announcement = storeConfig?.announcements?.find(announcement =>
      announcement.page.includes(page));
    return announcement ?? null;
  }

  getBadges(): ProductBadge[] {
    const storeConfig = this.storeConfigurationRepositoryService.storeConfigurations();
    return storeConfig?.badges || [];
  }
}
